
import { Empty } from 'antd'

export function EmptyComponent({ ...props }) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} {...props} />
}

export default EmptyComponent
